<template>
  <div class="animated fadeIn">
    <b-card style="height: 100%">
      <div v-if="selected ==='Year'">
        <b-row>
          <b-col sm="5">
            <h4 id="traffic" class="card-title mb-0">Traffic History this year</h4>
            <small>Volume of leads that entered the platform per month this year.</small>
          </b-col>
          <b-col sm="7" class="d-none d-md-block">
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-secondary"
                v-model="selected"
                name="radiosBtn"
              >
                <!-- <b-form-radio class="mx-0" value="Day">Day</b-form-radio> -->
                <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
                <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
              </b-form-radio-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <main-chart-example
          chartId="main-chart-01"
          class="chart-wrapper"
          style="height:300px;margin-top:40px;"

          height="300"

        />
      </div>
      <div v-if="selected === 'Month'">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Browsing history of the last three months</h4>
            <small>Visits from the last three months.</small>
          </b-col>
          <b-col sm="5" class="d-none d-md-block">
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-secondary"
                v-model="selected"
                name="radiosBtn"
              >
                <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
                <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
              </b-form-radio-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <TabelaDepaginasMaisVisitadasNoMes
          chartId="main-chart-01"
          class="chart-wrapper"
          style="height:auto;margin-top:40px;"
          :height="150"
        />
      </div>
    </b-card>
    <listaPaginasMaisAcessadas />
  </div>
</template>

<script>
import { Callout } from '@coreui/vue';
import { mapGetters, mapActions } from 'vuex';
import MainChartExample from './dashboard/MainChartExample.vue';
import TabelaDepaginasMaisVisitadasNoMes from './dashboard/TabelaDepaginasMaisVisitadasNoMes';
import listaPaginasMaisAcessadas from './dashboard/listaPaginasMaisAcessadas';

export default {
  name: 'dashboard',
  components: {
    Callout,
    MainChartExample,
    TabelaDepaginasMaisVisitadasNoMes,
    listaPaginasMaisAcessadas,
  },

  data() {
    return {
      selected: 'Year',
    };
  },

};

</script>
